import React, { Component } from "react";
import { changeOverlayStatus } from "../../state/actionCreators/index";
import { connect } from "react-redux";
import apiInstance from "../apiInstance";
import Button from "../Button";

class ResendMailPopUp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      displayPopup: false,
      fieldErrors: null,
      error: null,
      success: false,
    };
  }

  openPopup = (email) => {
    this.setState({
      email: email,
      displayPopup: true,
      fieldErrors: null,
      error: null,
      success: false,
    });
    this.props.changeOverlayStatus("true");
  };

  closePopup = () => {
    this.setState({
      displayPopup: false,
    });
    this.props.changeOverlayStatus("false");
  };

  handleEmailVerification = () => {
    const request_body = {
      email: this.state.email,
    };

    apiInstance
      .post("/user/verifyEmailRequest", request_body)
      .then((response) => {
        this.setState({
          success: true,
          error: null,
          fieldErrors: null,
        });
      })
      .catch((error) => {
        this.setState({
          fieldErrors: error.response.data.fieldErrors,
          error: null,
        });
      });
  };

  render() {
    const { displayPopup, email, success, error, fieldErrors } = this.state;

    return (
      <div
      style={{
        color : "black"
      }}
        className={
          "mjwi-popup mjwi-resend-mail-popup" +
          (displayPopup ? "" : " mjwi-hidden")
        }
      >
        <div className="mjwi-popup-content">
          <span className="mjwi-popup-close" onClick={this.closePopup}>
            <i className="fa-solid fa-xmark"></i>
          </span>
          <h3>Verify Email</h3>
          <p>Please verify your email before you proceed</p>

          {success && (
            <div style={{color : "green"}} className="mjwi-success-message">
              Email sent successfully
            </div>
          )}

          {error && <div className="mjwi-error-message">{error}</div>}

          {fieldErrors && (
            <div className="mjwi-field-errors">
              {Object.entries(fieldErrors).map(([field, message]) => (
                <p key={field}>{message}</p>
              ))}
            </div>
          )}

          <div className="mjwi-popup-actions">
            <Button
              name={success ? "Email Sent" : "Verify Email"}
              eventHandler={this.handleEmailVerification}
            />

            <Button name="Close" eventHandler={this.closePopup}></Button>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    overlay: state.overlay,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    changeOverlayStatus: (status) => {
      dispatch(changeOverlayStatus(status));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps, null, {
  forwardRef: true,
})(ResendMailPopUp);
